import $ from 'jquery';
import { LazyLoadManager } from '../app';

export default () => {
    const filterForm = $('#Sidebar-form');
    const productList = $('#category-products');

    const sendForm = (params = filterForm.serialize()) => {
        $.ajax(filterForm.attr('action'), {
            method: "POST",
            data: params,
            beforeSend: function() {
                productList.addClass('loading');
            },
        })
        .done(function(data) {
                
            productList.html(data);
            LazyLoadManager.update();
            productList.removeClass('loading');
            window.history.replaceState('', '', '?' + params);

          })
          .fail(function() {
            console.log( "error" );
          })
          .always(function() {
            
          });
    }


    filterForm.on('submit', function(e) {
        e.preventDefault();
        sendForm();
    })
    filterForm.find('input, select').on('change', function() {
        filterForm.submit();
    })
}


// WEBPACK FOOTER //
// ./assets/src/js/modules/Sidebar.js